// extracted by mini-css-extract-plugin
export default {"messageBoxContainer":"MessageBox_messageBoxContainer__1BU3v","message":"MessageBox_message__QKX8r"};